// extracted by mini-css-extract-plugin
export default {"forStore__store":"ForStore_forStore__store__-vR9o","forStore__store__img":"ForStore_forStore__store__img__f9Nsq"};